
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import DirectContactSection from './components/DirectContactSection';
import MapSection from './components/MapSection';
import ToolsSection from '../../components/feature/ToolsSection';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSection />
        <MapSection />
        <DirectContactSection />
        <ToolsSection />
        {/* <CTASection /> */}
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
